import ChallengeText from './ChallengeText';

export default ChallengeText;
